import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import Checkbox from 'components/Checkbox';

import styles from './CheckboxGroup.module.css';

type Props = {
  options: [string, string][];
  defaultSelected?: string;
  onSelect: (selected: string | undefined) => void;
};

// NOTE: Currently, the component only supports selecting a single option.
const CheckboxGroup = ({ options, defaultSelected, onSelect }: Props) => {
  const [selected, setSelected] = useState(defaultSelected);
  const form = useForm();

  const onChange = useCallback(
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const newSelect = event.target.checked ? key : undefined;
      setSelected(newSelect);
      onSelect(newSelect);
    },
    [],
  );

  return (
    <>
      {options.map(([key, label], index) => (
        <div className={styles.checkboxItem} key={`${key}-${label}-${index}`}>
          <Checkbox
            form={form}
            name={`${key}-${label}-${index}`}
            label={label}
            checked={selected === key}
            onChange={onChange(key)}
          />
        </div>
      ))}
    </>
  );
};

export default CheckboxGroup;
